import React from 'react';
import { useUserData } from '../../redux/hooks/useUserData';

/**
 * ProviderCard component
 * Displays the provider information and estimated wait time
 */
const ProviderCard = ({ waitTimeInfo }) => {
  const { providerInfo } = useUserData();
  
  // Check if provider info exists
  const hasProviderInfo = providerInfo?.firstName && providerInfo?.lastName;
  
  // Check if we have valid wait time info
  const hasWaitTimeInfo = waitTimeInfo && 
    waitTimeInfo.estimatedTime && 
    waitTimeInfo.providerName && 
    waitTimeInfo.message;
  
  // Default values if provider info is not available
  const image = hasProviderInfo ? 
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'%3E%3Ccircle cx='60' cy='60' r='50' fill='%23e6e7ff'/%3E%3Cpath d='M60 70c11 0 20-9 20-20s-9-20-20-20-20 9-20 20 9 20 20 20zm0 10c-13.3 0-40 6.7-40 20v10h80v-10c0-13.3-26.7-20-40-20z' fill='%235f63f2'/%3E%3C/svg%3E" : 
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'%3E%3Ccircle cx='60' cy='60' r='50' fill='%23e6e7ff'/%3E%3Cpath d='M60 70c11 0 20-9 20-20s-9-20-20-20-20 9-20 20 9 20 20 20zm0 10c-13.3 0-40 6.7-40 20v10h80v-10c0-13.3-26.7-20-40-20z' fill='%235f63f2'/%3E%3C/svg%3E";
  
  // Use provider name from wait time info or fallback to user data or default
  const name = hasWaitTimeInfo && waitTimeInfo.providerName !== 'Your provider' ? 
    waitTimeInfo.providerName : 
    (hasProviderInfo ? `Dr. ${providerInfo.firstName} ${providerInfo.lastName}` : "Your provider");
  
  // Determine message to display
  const waitMessage = hasWaitTimeInfo ? 
    waitTimeInfo.message : 
    "'s availability is currently not known. Please check again in few minutes.";
  
  const specialty = "";
  const rating = "4.9";
  const reviewCount = "127";

  return (
    <div className="mb-4" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        border: '1px solid #f0f0f0'
      }}>
        <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ marginRight: '15px' }}>
              <img
                src={image}
                alt="Provider"
                style={{
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: '3px solid #5f63f2'
                }}
              />
            </div>
            <div>
              <h5 style={{ margin: '0 0 4px 0', fontWeight: '600' }}>{name}</h5>
              <p style={{ margin: '0 0 4px 0', color: '#6c757d', fontSize: '14px' }}>{specialty}</p>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ color: '#FFB400', marginRight: '5px' }}>
                  <i className="fas fa-star" style={{ fontSize: '14px' }}></i>
                  <i className="fas fa-star" style={{ fontSize: '14px' }}></i>
                  <i className="fas fa-star" style={{ fontSize: '14px' }}></i>
                  <i className="fas fa-star" style={{ fontSize: '14px' }}></i>
                  <i className="fas fa-star" style={{ fontSize: '14px' }}></i>
                </div>
                <span style={{ color: '#6c757d', fontSize: '14px' }}>{rating} ({reviewCount} reviews)</span>
              </div>
            </div>
          </div>
        </div>

        <hr style={{ margin: '0', borderTop: '1px solid #eee' }} />

        <div style={{ padding: '15px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{
              backgroundColor: '#e6e7ff',
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: '10px'
            }}>
              <i className="far fa-clock" style={{ color: '#5f63f2', fontSize: '16px' }}></i>
            </div>
            <div>
              <div style={{ fontSize: '14px', color: '#6c757d' }}>Estimated wait time</div>
              <div style={{ fontSize: '14px' }}>{name} {waitMessage}</div>
            </div>
          </div>
          {hasWaitTimeInfo && (
            <div style={{ color: '#5f63f2', fontWeight: '600' }}>
              <span style={{ fontSize: '24px' }}>~ {waitTimeInfo.estimatedTime}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProviderCard;
